import { render, staticRenderFns } from "./PaginationInfinityScroll.vue?vue&type=template&id=578ca5ab"
import script from "./PaginationInfinityScroll.vue?vue&type=script&lang=js"
export * from "./PaginationInfinityScroll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports